<template>
  <div class="SettingRight">
    <div class="settingPageRightTitle">支付密码重置</div>
    <div class="settingPageRightContent">
      <div class="settingPageRightContentTitle">支付密码重置</div>

      <div>
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          size="small"
          v-loading="loading"
          class="demo-form"
        >
          <el-form-item label="支付手机号:">
            <div class="formItem">
              <div class="formInputItem">
                <el-input
                  
                  placeholder="请输入支付手机号"
                  :maxlength="11"
                  v-model="form.telephone.value"
                ></el-input>
              </div>
              <span v-if="form.telephone.warning" class="warning">{{
                form.telephone.warning
              }}</span>
            </div>
          </el-form-item>
          <el-form-item label="新支付密码:">
            <div class="formItem">
              <div class="formInputItem">
                <el-input
                  placeholder="密码为6位数字"
                  auto-complete="new-password"
                  show-password
        
                  v-model="form.pwd.value"
                ></el-input>
              </div>
              <span v-if="form.pwd.warning" class="warning">{{
                form.pwd.warning
              }}</span>
            </div>
          </el-form-item>
          <el-form-item label="确认支付密码:">
            <div class="formItem">
              <div class="formInputItem">
                <el-input
                  placeholder="密码为6位数字"
                  show-password
                  auto-complete="new-password"
                 
                  v-model="form._pwd.value"
                ></el-input>
              </div>
              <span v-if="form._pwd.warning" class="warning">{{
                form._pwd.warning
              }}</span>
              <span
                v-else-if="
                  form.pwd.value &&
                  form._pwd.value &&
                  form.pwd.value != form._pwd.value
                "
                class="warning"
                >*两次密码输入不一致</span
              >
            </div>
          </el-form-item>
          <el-form-item label="验证码:">
            <div class="sendMsg">
              <div class="sendMsgBox formInputItem">
                <div>
                  <el-input
                    v-model="form.code.value"
                    size="small"
                    maxlength="6"
                    placeholder="输入验证码"
                  ></el-input>
                </div>
                <el-button
                  @click="sendPayMessage"
                  size="small"
                  :loading="sendButtonLoading"
                  :disabled="sendMsgDisabled"
                  type="danger"
                  :style="{ borderRadius: 0 }"
                  >{{ msg }}</el-button
                >
              </div>
              <span v-if="form.code.warning" class="warning">{{
                form.code.warning
              }}</span>
            </div>
          </el-form-item>

          <el-form-item label="">
            <div class="tips">*此密码仅用于肉联所支付。</div>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="submitForm('form')"
              >重置支付密码</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  setStorePayPwdUrl,
  setPayPwdUrl,
  getAuthRoleUrl,
  sendCodeMessageUrl,
  updatePwdWithCodeUrl,
  resetPayPwd,
resetStorePayPwd
} from "@/api/api";
export default {
  name: "resetPayPwd",
  data() {
    return {
      form: {
        telephone: {
          value: "",
          reg: [
            { rule: /\S/, info: "*请输入支付手机号" },
            { rule: /^[0-9]{11}$/, info: "*手机号格式有误" },
          ],
          warning: "",
        },
        pwd: {
          value: "",
          reg: [
            {
              rule: /^[0-9]{6}$/,
              info: "*密码应为6位数字",
            },
          ],
          warning: "",
        },
        _pwd: {
          value: "",
          reg: [
            {
              rule: /^[0-9]{6}$/,
              info: "*密码应为6位数字",
            },
          ],
          warning: "",
        },
        code: {
          value: "",
          reg: [{ rule: /\S/, info: "*请输入验证码" }],
          warning: "",
        },
      },
      loading: false,
      msg: "验证码",
      time: 60,
      sendMsgDisabled: false,
      sendButtonLoading: false,
      code: "",
      timer:null
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    cutDown() {
      let time = this.time
      this.sendMsgDisabled = true;
      this.msg = time + "s";

       this.timer = setInterval(() => {
        if (time > 1) {
          time--;
          this.time = time;
          this.msg = time + "s";
        } else {
          clearInterval(this.timer);
          
          this.sendMsgDisabled = false;
          this.msg = "验证码";
        }
      }, 1000);
    },
    sendPayMessage() {
      let { telephone } = this.form;
      if (!telephone.value) {
        let form = {
          ...this.form,
        };
        form.telephone.warning = "*请输入手机号";
        this.form = form;
        return;
      }

      if (!/^[0-9]{11}$/.test(telephone.value)) {
        let form = {
          ...this.form,
        };
        form.telephone.warning = "*手机号格式有误";
        this.form = form;
        return;
      }

      let form = {
        ...this.form,
      };
      form.telephone.warning = "";
      this.form = form;
      this.time = 60
      this.sendButtonLoading = true;
      this.msg = "发送中";
      let url = sendCodeMessageUrl;

      let data = {
        type: this.userInfo&&this.userInfo.access_token?5:4,//重置余额支付密码
        telephone: telephone.value,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.sendButtonLoading = false;
            this.msg = "验证码";
            this.cutDown();
          } else {
            this.sendButtonLoading = false;
            this.msg = "验证码";
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.sendButtonLoading = false;
          this.msg = "验证码";
          alert(err.msg);
        });
    },

    getCityData() {
      console.log("city");
      console.log(city);
      this.citysArr = city;
    },
    testAddPwd(form) {
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          let showTips = [];
          reg.forEach((item) => {
            if (!item.rule.test(value)) {
              form[k].warning = item.info;
              flag = false;
              showTips.push(true);
            } else {
              showTips.push(false);
            }
          });
          showTips.every((item) => item == false) && (form[k].warning = "");
        }
      }
      return flag;
    },
    submitForm() {
      if (this.testAddPwd(this.form)) {
        let { pwd, _pwd } = this.form;
        if (pwd.value != _pwd.value) {
          this.$alert("两次密码输入不一致!", "提示");
          return;
        }
        this.checkRights().then(this.resetPayPwd);
      }
    },
    checkRights() {
      return new Promise((resolve, reject) => {
        resolve();
        return;
        // let { storeId, access_token } = this.userInfo;
        // this.loading = true;
        // if (storeId) {
        //   let data = {
        //     access_token,
        //     store_id: storeId,
        //   };
        //   let param = new URLSearchParams();
        //   for (var k in data) {
        //     param.append(k, data[k]);
        //   }
        //   this.$axios({
        //     method: "post",
        //     data: param,
        //     url: getAuthRoleUrl,
        //   })
        //     .then((res) => {
        //       if (res.data.resultCode == 1) {
        //         let _data = res.data.data;
        //         if (_data && _data.indexOf("0") > -1) {
        //           resolve();
        //         } else {
        //           this.$alert("支付密码重置仅限店铺管理员操作");
        //           this.loading = false;
        //           reject();
        //         }
        //       } else {
        //         this.loading = false;
        //         this.$alert(res.data.resultMsg);
        //         reject();
        //       }
        //     })
        //     .catch((err) => {
        //       this.loading = false;
        //       this.$alert(err.msg);
        //       reject();
        //     });
        // } else {
        //   resolve();
        // }
      });
    },
    resetPayPwd() {
      this.loading = true;
      let { pwd, telephone, code } = this.form;

      let data = {
        access_token:this.userInfo&&this.userInfo.access_token,
        telephone: telephone.value,
        newPwd: this.$md5(pwd.value+""),
        code: code.value,
        store_id:this.userInfo.storeId?this.userInfo.storeId:''
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url:this.userInfo&&this.userInfo.access_token?resetStorePayPwd:resetPayPwd,
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.resultCode == 1) {
            let form = JSON.parse(JSON.stringify(this.form));
            for (var k in form) {
              form[k].value = "";
              form[k].warning = "";
            }
            this.form = form;
            this.$alert("重置成功!", "提示").then(() => {
              this.$router.go(-1);
            });
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(err.msg);
        });
    },
  },
};
</script>

<style scoped>
.SettingRight {
  margin-left: 40px;
  flex: 1;
  min-width: 600px;
}
.settingPageRightTitle {
  background-color: #f3f8fe;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #014d7f;
  padding-left: 10px;
}
.settingPageRightContentTitle {
  font-size: 14px;
  color: #f40;
  height: 40px;
  line-height: 40px;
  position: relative;
  left: -10px;
}

.formItem {
  display: flex;
}
.warning {
  color: #dd2727;
  margin-left: 10px;
}
.addressItem {
  display: flex;
  height: 36px;
  align-items: center;
}
.addressItemTag {
  border: 1px solid #666;
  padding: 0px 20px;
  margin-right: 20px;
  width: 120px;
  text-align: center;
}
.addressBoxItem {
  max-width: 1100px;
  height: 36px;
  display: flex;
  padding: 0 20px 0 0;
  border: 1px solid #fff;
  justify-content: space-between;
  margin-bottom: 10px;
}
._cascader {
  max-width: 185px;
}
.tips {
  color: #676767;
  font-size: 13px;
}
.sendMsg {
  display: flex;
}
.sendMsgBox {
  display: flex;
  align-items: center;
}
.sendMsgBoxInput {
  width: 130px;
}
.formInputItem {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingPage/components/ResetPayPwd.vue